import { useHistory } from 'react-router-dom';
import tickImage from "../../assets/images/tick.svg"
import Button from "../UI/Button";

const DistRegConfirmation = () => {
    const history = useHistory();

    const login = () => {
        history.push('/login');
    }

    return (
        <div className="grow">
            <div className="flex flex-col h-screen relative">
                <div className="confirmationHolder max-w-full sm:max-w-[900px] min-h-full  sm:min-h-[466px] bg-white flex items-center justify-center m-auto ">
                    <div className="px-5 sm:px-10 md:px-10 py-6 sm:py-10 lg:px-14 h-full overflow-auto">
                        <div className="flex justify-center h-full sm:items-stretch flex-col sm:flex-row">
                            <div className="tickIconHolder size-16 sm:size-[140px] mr-auto  w-16 sm:min-w-[140px] self-center shrink-0 hidden">
                                <img src={tickImage} alt="tick icon" className="size-full object-cover" />
                            </div>
                            <div className="message mt-5 sm:mt-0">
                                <div>
                                    <h2 className="text-[#354665] barlowMedium sm:text-4xl text-xl uppercase">CONGRATULATIONS</h2>
                                    <div className="*:text-[#333] *:font-normal sm:*:text-lg sm:*:leading-7 text-base leading-6">
                                        <p className="mt-5 sm:mt-8">Your registration for The Source has been successfully completed. Simply log in to explore everything The Source has to offer.</p>
                                    </div>
                                </div>
                                <div className="buttonHolder">
                                    <Button className="btn mt-8 submitBtn w-fit bg-primaryBlue h-[46px] px-5 py-[10px] font-bold leading-5 text-base justify-center  rounded text-white inline-flex items-center min-w-[140px]" onClick={login}>Login</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DistRegConfirmation;